import { Check } from 'lucide-react';

import {} from '@Components';
import { TrackedButton } from '@Components/ui-v2/tracked-button';

interface NotifyFormProps {
  submitted: boolean;
  onSubmit: () => void;
  compact?: boolean;
}

const NotifyForm = ({ submitted, onSubmit, compact }: NotifyFormProps) => {
  if (submitted) {
    return (
      <div className="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-success-50 border border-success-200 text-success-700 text-sm font-medium">
        <Check size={16} strokeWidth={2.5} />
        We&apos;ll email you as soon as access is granted.
      </div>
    );
  }

  return (
    <div className={`flex w-full ${compact ? 'justify-start' : 'justify-center'}`}>
      <TrackedButton buttonName="NOTIFY_ME_WHEN_READY" onClick={onSubmit} isSubmit={false}>
        Notify me when ready
      </TrackedButton>
    </div>
  );
};

export default NotifyForm;
